
import { BrowserRouter as Link, } from "react-router-dom";
import { Navbar, Nav, Button, FormControl, Dropdown, Image, Row } from 'react-bootstrap';
import { HeartFil, HeartFill } from 'react-bootstrap-icons'
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css'

import openCapacitorSite from '../../utils/browserUtils';








export const Privacy = () =>   {

    {
    return(
       <>
  <br></br>
       <div id='mobileNavbarSpacer'></div>
<div id='homebg'>  
 <div id='textPageMobile' style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        textAlign: 'center' 
                    }}>
           <h3 id='aboutParagraph'>Privacy</h3>
                    <br></br>
                    
                    
                    <p id='aboutParagraph'>Gov Glance does not collect any personal user information. 
                    Features like collection save news items directly to your device's local storage for your convenience
                    and is not shared with Gov Glance servers. We only use the default analytics provided by the Apple App Store. 
                    <br></br>
                  <a id='aboutLink' href='https://govglance.foundation/privacy'>Learn more</a>
                  </p>
                  </div>
        
                      </div>

          </>
  )
}
 }



  






export default Privacy;




